import {ControlManagerContent} from '../content'
import update from 'immutability-helper'

export class ControlManagerContainerContent {
  constructor(data) {
    this.content = {}
    this.construct(data)
    // this.resetOriginal()
  }

  getBlock(block) {
    let target = this.content[block]
    if (!target) {
      throw new Error(
        `ControlManagerContainerContent: block "${block}" does not exist.`,
      )
    }
    return target
  }

  getValue(block, name) {
    return this.getBlock(block).getValue(name)
  }

  setValue(block, name, value) {
    return this.getBlock(block).setValue(name, value)
  }

  getSource(block, location) {
    return this.getBlock(block).getSource(location)
  }

  setSource(block, location, value) {
    return this.getBlock(block).setSource(location, value)
  }

  getTree(block) {
    return this.getBlock(block).getTree()
  }

  setTree(block, tree) {
    return this.getBlock(block).setTree(tree)
  }

  validateTree(block, source, schema) {
    return this.getBlock(block).validateTree(source, schema)
  }

  resetOriginal() {
    this.originalContent = JSON.parse(JSON.stringify(this.content))
  }

  construct(data = {}) {
    if (typeof data !== 'object') {
      throw new Error('Data must be a valid JSON object.')
    }
    for (const key in data) {
      const datum = data[key]
      // console.log('constructing conman', key)
      // console.log('it has datum', datum)
      this.content[key] = new ControlManagerContent(datum)
    }
    // console.log('generated content', this)
    return this
  }

  constructFromRefTable(refs) {
    const data = {}
    // console.log('got refs', refs)
    for (const key in refs) {
      const ref = refs[key].current
      if (ref && ref.getSchema) {
        data[key] = {
          schema: ref.getSchema(false),
          source: ref.getSource(false),
          tree: ref.getTree(false),
        }
      }
    }
    // console.log('constructing from ref table with data', data)
    return this.construct(data)
  }

  serialize() {
    const {content} = this
    // console.log('serializing content', content)
    const res = {}
    for (const key in content) {
      // console.log('serializing key', key, content[key])
      if (content[key].serialize) {
        res[key] = content[key].serialize()
      } else if (content[key].schema) {
        // console.log('something wrong')
        res[key] = content[key]
      }
      // console.log(res[key])
    }
    return res
  }

  getDelta(newData = this.originalContent, oldData = this) {
    if (oldData.content) oldData = oldData.content
    if (newData.content) newData = newData.content
    // console.log('getting delta for newData and oldData', typeof newData, typeof oldData)
    let ownKeys = Object.keys(oldData)
    let res = {}
    for (const key in newData) {
      // console.log('checking key %s in newData', key, typeof newData[key], typeof oldData[key])
      if (oldData[key]) {
        ownKeys = ownKeys.filter((elm) => elm !== key)
        // console.log('found and removed key', key, ownKeys)
        const delta = oldData[key].getDelta(newData[key])
        if (delta && delta.length) res[key] = delta
      } else {
        // content does not have this index; it should be wholly added
        res._added = res._added || {}
        res._added[key] = newData[key]
      }
    }
    if (ownKeys.length) res._deleted = ownKeys

    if (Object.keys(res).length === 0) res = null

    return res
  }

  setDelta(data) {
    let keys = Object.keys(data)
    const added = data._added
    const deleted = data._deleted
    keys = keys.filter((elm) => elm !== '_added' && elm !== '_deleted')
    for (const key of keys) {
      if (this.content[key]) {
        try {
          this.content[key].setDelta(data[key])
        } catch(e){
          // console.log('Problem setting delta!')
          console.warn(e)
          throw new Error(`Can't set delta to key ${key}: ${e.message}`)
        }
      } else
        throw new Error(
          `Can't set delta to key ${key}: it does not exist in the content`,
        )
    }
    if (added) {
      for (const key in added) {
        this.content[key] = new ControlManagerContent(added[key])
      }
    }

    // console.log('deleting these', deleted)
    if (deleted && deleted.length)
      this.content = update(this.content, {$unset: deleted})
    return this
  }

  hydrate(includes) {
    const {content} = this
    for( const key in content ){
      // console.log('content hydrating', key)

      this.content[key] = content[key].hydrate(includes)
    }
    return this
  }

  getData(compress, target) {
    const {content} = this
    const res = {}
    // console.log('get content', this)
    if (typeof target !== 'undefined') {
      if (content[target]) {
        return content[target].getData(compress)
      } else {
        throw new Error(
          `ControlManagerContainerContent: cannot get data for index ${target}: no such index`,
        )
      }
    }
    for (const key in content) {
      // console.log('gd', key)
      if (content[key].getData) res[key] = content[key].getData(compress)
    }
    return res
  }

  setTemplates(target, templates) {
    const {content} = this
    if (typeof target !== 'undefined' && target !== null) {
      if (content[target]) {
        return content[target].setTemplates(templates)
      } else {
        throw new Error(
          `ControlManagerContainerContent: cannot get data for index ${target}: no such index`,
        )
      }
    }
    for (const key in content) {
      content[key].setTemplates(templates)
    }
  }

  getIncludeStrings() {
    const data = this.getData(true)
    // console.log('generating include strings from data', data)
    const allIncludes = []
    for (const key in data) {
      if (data[key] && data[key].includes) {
        for (const item of data[key].includes) {
          if (!allIncludes.includes(item)) allIncludes.push(item)
        }
      }
    }
    return allIncludes
  }
}
